import React, {useContext, useEffect} from "react"
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Select, {SelectOption} from "@amzn/meridian/select";
import {StageFilterContext} from "./context/StageFilterContext";
import Tag from "@amzn/meridian/tag";
import {injectIntl} from "react-intl";
import {getStageStatusList} from "../util/EntityStatusManager";
import ExportCSV from "../exportcsv/ExportCSV";
import {getStageDataInCSVFormat} from "../util/ExportUtils";
import {RouteStageContext} from "./context/RouteStageContext";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {STAGE_LOCATION_TYPE, DEFAULT_CAPABILITIES} from "../util/Constants";
import {getFilterTagLabel} from "../util/FilterUtil";
import RefreshTimer from "../util/RefreshTimer";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const StageFilterV2 = (props) => {
    const {viewModelF, dispatchF} = useContext(StageFilterContext)
    const {configViewModel} = useContext(CapabilityContext)
    const {viewModel} = useContext(RouteStageContext)
    const {spacingInset_shorthand2} = useDeviceLayout()

    const stageDataConversionHandler = () => {
        return getStageDataInCSVFormat(viewModel.cartList,
            viewModel.routeList,
            viewModelF.viewType,
            configViewModel.capability,
            configViewModel.stationConfig);
    }

    const isFilterSet = () => {
        let result = false;
        Object.entries(viewModelF).forEach(entry => {
            const key = entry[0];
            const values = entry[1];
            result = result || (Array.isArray(values) && values.length && key !== 'data');
        });
        return result;
    }

    const clearAllFilters = () => {
        dispatchF({type: 'REMOVE_ALL_FILTER'});
    }

    const isXPTFilterRequired = () => {
        const xptNodes = viewModelF.data.xptNodes;
        return Array.isArray(xptNodes) && xptNodes.length && DEFAULT_CAPABILITIES.includes(configViewModel.capability);
    }

    useEffect(() => {
        dispatchF({type: 'LOAD_FILTERS'});
        dispatchF({
            type: 'LOAD_XPT_NODES',
            data: {
                dispatcher: dispatchF,
                baseUrl: configViewModel.baseUrl,
                capability: configViewModel.capability,
                stationConfig: configViewModel.stationConfig
            }
        });
    }, []);

    return (
        <Column spacingInset={spacingInset_shorthand2} spacing={"none"}>
                <Row width="100%" spacingInset="none" alignmentHorizontal={"right"}>
                    <ExportCSV isLink={true} csvDataProvider={stageDataConversionHandler} filePrefix={"STAGE"} />
                </Row>
            <Row wrap={"down"} width="100%" spacingInset="medium small" spacing="small" backgroundColor="secondary">
                {isXPTFilterRequired() ?
                    <Select
                        onChange={(data) => dispatchF({type: 'SELECT_XPT_NODE', xptNodes: data})}
                        value={viewModelF.xptNodes}
                        size="small"
                        placeholder={props.intl.formatMessage({id: "stage.xptNodes", defaultMessage: "XPT Nodes"})}
                        width={"120px"}>
                        {[...viewModelF.data.xptNodes].sort().map(xptNode => (
                            <SelectOption key={xptNode} label={xptNode} value={xptNode} />
                        ))}
                    </Select>
                    : null
                }
                <Select
                    onChange={(data) => dispatchF({type: 'SELECT_DEPARTURE', Departure: data})}
                    value={viewModelF.departure}
                    size="small"
                    placeholder={props.intl.formatMessage({id: "stage.stageByTime", defaultMessage: "Stage by time"})}
                    width={"145px"}>
                    {[...viewModelF.data.departure].sort().map(departure => (
                        <SelectOption key={departure} label={"Stage by " + departure}
                            value={departure} />
                    ))}
                </Select>
                <Select
                    onChange={(data) => dispatchF({type: 'SELECT_DRIVER_TYPE', DriverType: data})}
                    value={viewModelF.driverType}
                    size="small"
                    placeholder={props.intl.formatMessage({
                        id: "stageFilter.driverType",
                        defaultMessage: "Driver Type"
                    })}
                    width={"125px"}>
                    {[...viewModelF.data.driverType].sort().map(driverType => (
                        <SelectOption key={driverType} label={driverType} value={driverType} />
                    ))}
                </Select>
                <Select
                    onChange={(data) => dispatchF({type: 'SELECT_CLUSTER', Cluster: data})}
                    value={viewModelF.cluster}
                    size="small"
                    placeholder={props.intl.formatMessage({id: "stageFilter.cluster", defaultMessage: "Cluster"})}
                    width={"115px"}>
                    {[...viewModelF.data.cluster].sort().map(cluster => (
                        <SelectOption key={cluster} label={cluster} value={cluster} />
                    ))}
                </Select>
                <Select
                    onChange={(data) => dispatchF({type: 'SELECT_STATUS', status: data})}
                    value={viewModelF.status}
                    size="small"
                    placeholder={props.intl.formatMessage({id: "cartInfo.status", defaultMessage: "Status"})}
                    width={"120px"}>
                    {getStageStatusList(viewModelF.viewType, configViewModel.stationConfig).map(status => (
                        <SelectOption key={status} label={status} value={status} />
                    ))}
                </Select>
                {configViewModel.stationConfig.highSPREnabled ?
                    <Select
                        onChange={(data) => dispatchF({type: 'SELECT_STAGE_LOCATION_TYPE', stageLocationType: data})}
                        value={viewModelF.stageLocationType}
                        size="small"
                        placeholder={props.intl.formatMessage({id: "cartInfo.stageLocationType", defaultMessage: "Location Type"})}
                        width={"137px"}>
                        <SelectOption key={STAGE_LOCATION_TYPE.OVERFLOW}
                            label={props.intl.formatMessage({
                                id: "cartInfo.overflowStatus",
                                defaultMessage: "Overflow"
                            })}
                            value={STAGE_LOCATION_TYPE.OVERFLOW} />
                    </Select>
                    : null
                }
            </Row>

            <Row width="100%" spacingInset="small none none none">
                <Row spacing={"small"}>
                    {Object.entries(viewModelF).map(entry => {
                        const key = entry[0]
                        const values = entry[1]
                        return (
                            (Array.isArray(values) && key !== 'data') ? values.map(value => {
                                return <Tag key={value} type="theme"
                                    onClose={() => dispatchF({
                                        type: 'REMOVE_FILTER',
                                        data: {key, value}
                                    })}>{getFilterTagLabel(key, value)}</Tag>
                            }) : null
                        )
                    })}
                    {isFilterSet() ? <Link onClick={clearAllFilters} type="secondary">Clear all</Link> : null}
                </Row>
            </Row>

            <Row spacingInset="small none">
                <RefreshTimer deps={[viewModel.lastUpdated]} lastUpdated={viewModel.lastUpdated} />
            </Row>
        </Column>
    )
}

export default injectIntl(StageFilterV2)



// WEBPACK FOOTER //
// ./src/components/stageStatus/StageFilterV2.js